import { useEffect } from 'react';
import isObject from 'lodash/isObject';
import { useFormikContext, FormikErrors, FormikValues } from 'formik';
import { errorElementsSelector } from './helpers';

const getFirstErrorKey = (
  object: FormikErrors<FormikValues>,
  keys: string[] = [],
): string => {
  const [firstErrorKey, firstErrorValue] = Object.entries(object)[0];
  if (isObject(object[firstErrorKey])) {
    return getFirstErrorKey(firstErrorValue as FormikErrors<FormikValues>, [
      ...keys,
      firstErrorKey,
    ]);
  }
  return [...keys, firstErrorKey].join('.');
};

const FormikOnError = ({
  children,
  onError,
  forceShow,
}: {
  children: JSX.Element;
  onError?(errorKey: string, errorElement: HTMLElement): void;
  forceShow?: boolean;
}): JSX.Element => {
  const { isValid, isSubmitting, errors } = useFormikContext<FormikValues>();

  useEffect(() => {
    if ((!isValid && isSubmitting === true) || forceShow) {
      const firstErrorKey = getFirstErrorKey(errors);

      const errorElement =
        (document.querySelector(
          errorElementsSelector[firstErrorKey],
        ) as HTMLElement) ||
        global.window.document.getElementsByName(firstErrorKey)[0] ||
        document.querySelector(`[name^="${firstErrorKey}"]`);
      if (errorElement) {
        onError && onError(firstErrorKey, errorElement);
        errorElement.scrollIntoView({ block: 'center', inline: 'center' });
      }
    }
  }, [isSubmitting, isValid, errors, forceShow]);
  return children;
};

export default FormikOnError;
